<dw-meta-data-grid  item="UserYearNumbers" [filters]="filterGroup" configKeyPart='TeamYearGrid'></dw-meta-data-grid>
